import {
  SHOW_OTP,
  SET_PASSWORD_OTP_REQUEST_ID,
  SET_PASSWORD_TOKEN,
  SEND_PASSWORD_OTP_REQUEST,
  FP_OTP_ERROR,
  PASSWORD_CHANGE_BY,
  VERIFY_PASSWORD_OTP,
  GENERATE_PASSWORD_OTP,
} from './types';

export function showOtp(params) {
  return { type: SHOW_OTP, payload: params };
}

export function setPasswordOtpRequestId(requestId) {
  return {
    type: SET_PASSWORD_OTP_REQUEST_ID,
    payload: { request_id: requestId },
  };
}

export function setPasswordToken(token) {
  return { type: SET_PASSWORD_TOKEN, payload: { token } };
}

export function otpError(params) {
  return { type: FP_OTP_ERROR, payload: { otpError: params } };
}

export function passwordChangeBy(changeBy) {
  return { type: PASSWORD_CHANGE_BY, payload: { changeBy } };
}

export function sendPasswordOtpRequest(data) {
  return { type: SEND_PASSWORD_OTP_REQUEST, payload: { data } };
}

export function verifyPasswordOtp(data) {
  return { type: VERIFY_PASSWORD_OTP, payload: { data } };
}

export function generatePasswordOtpRequest(data) {
  return { type: GENERATE_PASSWORD_OTP, payload: { data } };
}
